import React, { useState, useEffect, useRef } from 'react';
import './Countdown.css';


function Countdown() {
  const [targetDate, setTargetDate] = useState('');
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [active, setActive] = useState(false);
  const [alarmPlaying, setAlarmPlaying] = useState(false);
  const [alarmChoice, setAlarmChoice] = useState('/sounds/alarm.wav'); // Default alarm
  const audioRef = useRef(null);

  useEffect(() => {
    let timerId;
    if (active && targetDate) {
      timerId = setInterval(() => {
        const diff = new Date(targetDate) - new Date();
        if (diff <= 0) {
          clearInterval(timerId);
          setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          setAlarmPlaying(true);
          if (audioRef.current) {
            audioRef.current.loop = true; // Repeat alarm
            audioRef.current.play();
          }
        } else {
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
          const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((diff / (1000 * 60)) % 60);
          const seconds = Math.floor((diff / 1000) % 60);
          setTimeLeft({ days, hours, minutes, seconds });
        }
      }, 1000);
    }

   
    return () => clearInterval(timerId);
  }, [active, targetDate]);

  const handleStart = () => {
    if (targetDate) {
      setActive(true);
      setAlarmPlaying(false);
    }
  };

  const stopAlarm = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setAlarmPlaying(false);
  };

  return (
    <div className="utility-box">

      <h4>Countdown Timer</h4>
<label className="mb-1 fw-bold text-primary">📅 Select Target Date & Time:</label>
<input
  type="datetime-local"
  className="custom-datetime mb-3"
  value={targetDate}
  onChange={(e) => setTargetDate(e.target.value)}
/>




     <div className="mb-3">
  <label className="fw-bold text-success">🎵 Choose Alarm Sound:</label>
  <select
    className="form-select alarm-selector"
    value={alarmChoice}
    onChange={(e) => setAlarmChoice(e.target.value)}
  >
    <option value="/sounds/alarm.wav">🔔 Panic</option>
    <option value="/sounds/morning.wav">🌅 Morning Buzz</option>
    <option value="/sounds/funny.wav">😂 Funny</option>
    <option value="/sounds/parrot.wav">🦜 Parrot Wake Up</option>
    <option value="/sounds/emergency.wav">🚨 Emergency Call</option>
    <option value="/sounds/winner.wav">🏆 Winner Call</option>
    <option value="/sounds/police.wav">👮 Police Call</option>
  </select>

  <div className="d-flex gap-2 mt-2">
    <button
      className="btn btn-outline-success btn-sm"
      onClick={() => {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          audioRef.current.play();
        }
      }}
    >
      ▶️ Preview Alarm
    </button>

    <button
      className="btn btn-outline-danger btn-sm"
      onClick={() => {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
        }
      }}
    >
      🔕 Stop Preview
    </button>
  </div>
</div>



      <button className="btn btn-primary mb-2" onClick={handleStart}>Start Countdown</button>

      <div className="mt-4 text-center">
        <h5 className="mb-3">⏰ Time Remaining:</h5>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          {['days', 'hours', 'minutes', 'seconds'].map((unit) => {
            const isDanger =
              active &&
              unit === 'seconds' &&
              timeLeft.seconds <= 10 &&
              timeLeft.seconds > 0 &&
              timeLeft.minutes === 0 &&
              timeLeft.hours === 0 &&
              timeLeft.days === 0;

            return (
              <div
                key={unit}
                className={`countdown-box p-3 border rounded text-center ${
                  isDanger ? 'countdown-danger' : 'bg-light'
                }`}
              >
                <h4 className="m-0">{timeLeft[unit]}</h4>
                <small className="text-muted text-uppercase">{unit}</small>
              </div>
            );
          })}
        </div>
      </div>

      {alarmPlaying && (
        <div className="text-center mt-3">
          <button className="btn btn-danger" onClick={stopAlarm}>🔕 Stop Alarm</button>
        </div>
      )}

      <audio ref={audioRef} src={alarmChoice} preload="auto" />
    </div>
  );
}

export default Countdown;
